var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03 1.624a1.305 1.305 0 0 0 1.94 0L9.6.932a1.306 1.306 0 0 1 2.273.942l-.047.934a1.307 1.307 0 0 0 1.367 1.37l.934-.048a1.306 1.306 0 0 1 .94 2.273l-.695.627a1.307 1.307 0 0 0 0 1.939l.695.627a1.305 1.305 0 0 1-.942 2.273l-.934-.047a1.307 1.307 0 0 0-1.37 1.37l.047.934a1.305 1.305 0 0 1-2.268.94l-.627-.694a1.306 1.306 0 0 0-1.94 0l-.63.694a1.306 1.306 0 0 1-2.27-.939l.048-.933a1.305 1.305 0 0 0-1.37-1.371l-.934.047A1.306 1.306 0 0 1 .933 9.6l.694-.628a1.307 1.307 0 0 0 0-1.939l-.694-.63a1.305 1.305 0 0 1 .94-2.27l.933.047a1.305 1.305 0 0 0 1.372-1.374l-.045-.934a1.306 1.306 0 0 1 2.271-.94l.627.692Z",
    stroke: "#fff",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    stroke: "#fff",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1ac5c9ff33453c5bb25795e7773e9ed1.svg";
export { ForwardRef as ReactComponent };